(function () {
  'use strict';

  /* ============================================================
     TERRAIN — Smart Seeding Tools (Phase 2/3)
     Germination tracker, micro-survey, review request,
     tool recommendations, product share.
     Operates on DOM elements placed by semer-app.liquid,
     reads seeding record from localStorage (set by semer-engine.js).
     ============================================================ */

  /* --- Language detection (same logic as semer-engine.js) --- */
  var LANG = (window.Shopify && window.Shopify.locale ? window.Shopify.locale : (navigator.language || navigator.languages && navigator.languages[0] || 'fr')).startsWith('en') ? 'en' : 'fr';
  function pick(obj) { return obj[LANG] || obj.fr; }

  /* --- Bilingual strings --- */
  var T = {
    tracker_headline:  { fr: 'Suivi de germination', en: 'Germination tracker' },
    tracker_day_label: { fr: 'jours depuis le semis', en: 'days since seeding' },
    tracker_day_one:   { fr: 'jour depuis le semis', en: 'day since seeding' },
    tracker_window:    { fr: 'Germination attendue entre le jour {MIN} et le jour {MAX}.', en: 'Germination expected between day {MIN} and day {MAX}.' },
    tracker_soil:      { fr: 'Temp. du sol au semis : {TEMP}°C', en: 'Soil temp at seeding: {TEMP}°C' },

    /* Status messages by phase */
    status_early:      { fr: 'Patience — les graines sont en train de s\'enraciner sous la surface.', en: 'Patience — seeds are taking root below the surface.' },
    status_window:     { fr: 'Regardez bien! La germination devrait être visible maintenant.', en: 'Look closely! Germination should be visible now.' },
    status_late:       { fr: 'La levée devrait être complète. Voyez-vous du vert?', en: 'Sprouting should be complete. Do you see green?' },
    status_overdue:    { fr: 'Si vous ne voyez pas de levée, contactez-nous pour de l\'aide.', en: 'If you don\'t see growth, contact us for help.' },

    confirm_btn:       { fr: 'J\'ai vu la levée!', en: 'I see growth!' },
    confirmed:         { fr: '✓ Germination confirmée', en: '✓ Germination confirmed' },

    /* Micro-survey */
    survey_question:   { fr: 'Comment se passe la levée?', en: 'How is the germination going?' },
    survey_uniform:    { fr: 'Uniforme et dense', en: 'Uniform and dense' },
    survey_patchy:     { fr: 'Inégale par endroits', en: 'Patchy in places' },
    survey_help:       { fr: 'J\'ai des questions', en: 'I have questions' },

    /* Review request */
    review_headline_good: { fr: 'Merci! Partagez votre expérience.', en: 'Thank you! Share your experience.' },
    review_subline:    { fr: 'Votre avis aide d\'autres jardiniers du Québec.', en: 'Your review helps other Quebec gardeners.' },
    review_google:     { fr: 'Google Reviews', en: 'Google Reviews' },
    review_site:       { fr: 'Avis sur notre site', en: 'Review on our site' },

    /* Staff help (unsatisfied) */
    help_headline:     { fr: 'On est là pour vous aider.', en: 'We\'re here to help.' },
    help_subline:      { fr: 'Un conseiller TERRAIN vous contactera sous 24h.', en: 'A TERRAIN advisor will contact you within 24 hours.' },
    help_sent:         { fr: '✓ Demande envoyée — on vous contacte bientôt.', en: '✓ Request sent — we\'ll be in touch soon.' },

    /* Share */
    share_title:       { fr: 'Partagez TERRAIN avec un ami', en: 'Share TERRAIN with a friend' },
    share_btn:         { fr: 'Partager', en: 'Share' },
    share_text:        { fr: 'J\'utilise TERRAIN pour savoir quand semer mon gazon. Essaie-le!', en: 'I use TERRAIN to know when to seed my lawn. Try it!' },
    share_text_go:     { fr: 'C\'est le moment de semer! TERRAIN me dit que les conditions sont idéales.', en: 'Time to seed! TERRAIN says conditions are ideal.' },
    share_text_other:  { fr: 'Je planifie mon semis avec TERRAIN — un outil météo gratuit pour le Québec.', en: 'I\'m planning my seeding with TERRAIN — a free weather tool for Quebec.' },

    /* Tool recommendations */
    tools_heading:     { fr: 'Outils recommandés pour votre projet', en: 'Recommended tools for your project' },
    tools_view:        { fr: 'Voir le produit', en: 'View product' }
  };

  /* --- Germination windows per blend (mirrors semer-engine.js BLEND_CONFIG) --- */
  var GERM_WINDOWS = {
    ombre:    [7, 14],
    soleil:   [5, 10],
    aride:    [10, 18],
    vivant:   [7, 12],
    prairie:  [10, 21],
    golf:     [7, 14],
    melange_b:[10, 21]
  };

  /* Safe localStorage wrappers (Safari private browsing throws on writes) */
  function safeStorageGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeStorageSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) { /* silent */ }
  }

  /* --- DOM references --- */
  var DOM = {};
  function cacheDom() {
    DOM.tracker        = document.getElementById('smr-tracker');
    DOM.trackerHeadline= document.getElementById('smr-tracker-headline');
    DOM.trackerDays    = document.getElementById('smr-tracker-days');
    DOM.trackerDayLabel= document.getElementById('smr-tracker-day-label');
    DOM.trackerWindow  = document.getElementById('smr-tracker-window');
    DOM.trackerSoil    = document.getElementById('smr-tracker-soil');
    DOM.trackerStatus  = document.getElementById('smr-tracker-status');
    DOM.trackerConfirm = document.getElementById('smr-tracker-confirm');

    DOM.survey         = document.getElementById('smr-survey');
    DOM.surveyQuestion = document.getElementById('smr-survey-question');
    DOM.surveyOptions  = document.getElementById('smr-survey-options');

    DOM.review         = document.getElementById('smr-review');
    DOM.reviewHeadline = document.getElementById('smr-review-headline');
    DOM.reviewSubline  = document.getElementById('smr-review-subline');
    DOM.reviewButtons  = document.getElementById('smr-review-buttons');

    DOM.share          = document.getElementById('smr-share');

    DOM.tools          = document.getElementById('smr-tools');
    DOM.toolsHeading   = document.getElementById('smr-tools-heading');
    DOM.toolsGrid      = document.getElementById('smr-tools-grid');
  }

  /* ============================================================
     GERMINATION TRACKER
     ============================================================ */
  function initTracker() {
    var record = safeStorageGet('smr-seeding-record');
    if (!record) return;

    var data;
    try { data = JSON.parse(record); } catch (e) { return; }
    if (!data.date || !data.blend) return;

    var daysSince = Math.floor((Date.now() - new Date(data.date).getTime()) / 86400000);
    if (daysSince < 0 || daysSince > 60) return;

    // Check if germination already confirmed
    var confirmed = safeStorageGet('smr-germination-confirmed');

    // Get germination window
    var window_range = GERM_WINDOWS[data.blend] || [7, 14];
    var germMin = data.germinationMin || window_range[0];
    var germMax = data.germinationMax || window_range[1];

    // Populate tracker
    if (!DOM.tracker) return;

    DOM.trackerHeadline.textContent = pick(T.tracker_headline);
    DOM.trackerDays.textContent = daysSince;
    DOM.trackerDayLabel.textContent = daysSince === 1 ? pick(T.tracker_day_one) : pick(T.tracker_day_label);
    DOM.trackerWindow.textContent = pick(T.tracker_window).replace('{MIN}', germMin).replace('{MAX}', germMax);

    if (data.soilTemp != null) {
      DOM.trackerSoil.textContent = pick(T.tracker_soil).replace('{TEMP}', Math.round(data.soilTemp));
    } else {
      DOM.trackerSoil.hidden = true;
    }

    // Status message based on day count
    var statusMsg;
    if (daysSince < germMin) {
      statusMsg = pick(T.status_early);
    } else if (daysSince <= germMax) {
      statusMsg = pick(T.status_window);
    } else if (daysSince <= germMax + 7) {
      statusMsg = pick(T.status_late);
    } else {
      statusMsg = pick(T.status_overdue);
    }
    DOM.trackerStatus.textContent = statusMsg;

    // Confirm button
    if (confirmed) {
      DOM.trackerConfirm.textContent = pick(T.confirmed);
      DOM.trackerConfirm.disabled = true;
      DOM.trackerConfirm.classList.add('smr-tracker__confirm--done');

      // Check if survey already completed
      var surveyDone = safeStorageGet('smr-survey-done');
      if (surveyDone) {
        showPostSurveyState(surveyDone);
      } else {
        showSurvey(data);
      }
    } else {
      DOM.trackerConfirm.textContent = pick(T.confirm_btn);
      DOM.trackerConfirm.addEventListener('click', function () {
        handleGerminationConfirm(data);
      });
    }

    DOM.tracker.hidden = false;
  }

  function handleGerminationConfirm(seedingData) {
    safeStorageSet('smr-germination-confirmed', new Date().toISOString());

    // Klaviyo event
    var _learnq = window._learnq || [];
    var email = safeStorageGet('smr-customer-email');
    if (email) {
      _learnq.push(['identify', {
        '$email': email,
        'terrain_germination_confirmed': true,
        'terrain_germination_confirmed_date': new Date().toISOString().slice(0, 10)
      }]);
      _learnq.push(['track', 'TERRAIN Germination Confirmed', {
        'blend': seedingData.blend,
        'days_to_germination': Math.floor((Date.now() - new Date(seedingData.date).getTime()) / 86400000),
        'postal_code': seedingData.postalCode
      }]);
    }

    // Update button
    DOM.trackerConfirm.textContent = pick(T.confirmed);
    DOM.trackerConfirm.disabled = true;
    DOM.trackerConfirm.classList.add('smr-tracker__confirm--done');

    // Show micro-survey
    showSurvey(seedingData);
  }

  /* ============================================================
     MICRO-SURVEY
     ============================================================ */
  function showSurvey(seedingData) {
    if (!DOM.survey) return;

    DOM.surveyQuestion.textContent = pick(T.survey_question);
    DOM.surveyOptions.innerHTML = '';

    var options = [
      { key: 'uniform', label: pick(T.survey_uniform), icon: '✓' },
      { key: 'patchy',  label: pick(T.survey_patchy),  icon: '~' },
      { key: 'help',    label: pick(T.survey_help),    icon: '?' }
    ];

    options.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.className = 'smr-survey__btn';
      btn.type = 'button';
      btn.setAttribute('data-survey', opt.key);
      btn.innerHTML = '<span class="smr-survey__icon">' + opt.icon + '</span>' + opt.label;
      btn.addEventListener('click', function () {
        handleSurveyResponse(opt.key, seedingData);
      });
      DOM.surveyOptions.appendChild(btn);
    });

    DOM.survey.hidden = false;
  }

  function handleSurveyResponse(response, seedingData) {
    safeStorageSet('smr-survey-done', response);

    // Klaviyo event
    var _learnq = window._learnq || [];
    var email = safeStorageGet('smr-customer-email');
    if (email) {
      _learnq.push(['track', 'TERRAIN Germination Survey', {
        'blend': seedingData.blend,
        'response': response,
        'postal_code': seedingData.postalCode
      }]);
    }

    // Disable all buttons
    var btns = DOM.surveyOptions.querySelectorAll('.smr-survey__btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].disabled = true;
      if (btns[i].getAttribute('data-survey') === response) {
        btns[i].classList.add('smr-survey__btn--selected');
      }
    }

    showPostSurveyState(response);
  }

  function showPostSurveyState(response) {
    if (response === 'uniform' || response === 'patchy') {
      showReviewRequest();
    } else if (response === 'help') {
      showStaffHelp();
    }
  }

  /* ============================================================
     REVIEW REQUEST (satisfied customers)
     ============================================================ */
  function showReviewRequest() {
    if (!DOM.review) return;

    DOM.reviewHeadline.textContent = pick(T.review_headline_good);
    DOM.reviewSubline.textContent = pick(T.review_subline);
    DOM.reviewButtons.innerHTML = '';

    var trackReviewClick = function (platform) {
      if (window._learnq) {
        var now = new Date().toISOString();
        window._learnq.push(['track', 'TERRAIN Review Requested', {
          platform: platform,
          blend: window.__SEMER_STATE && window.__SEMER_STATE.blend || '',
          timestamp: now
        }]);
        window._learnq.push(['identify', {
          terrain_review_requested: true,
          terrain_review_requested_date: now
        }]);
      }
    };

    var googleBtn = document.createElement('a');
    googleBtn.className = 'smr-review__btn smr-review__btn--google';
    googleBtn.textContent = pick(T.review_google);
    googleBtn.href = 'https://g.page/fgedwards/review';
    googleBtn.target = '_blank';
    googleBtn.rel = 'noopener';
    googleBtn.addEventListener('click', function () { trackReviewClick('google'); });
    DOM.reviewButtons.appendChild(googleBtn);

    var siteBtn = document.createElement('a');
    siteBtn.className = 'smr-review__btn smr-review__btn--site';
    siteBtn.textContent = pick(T.review_site);
    siteBtn.href = '/pages/avis';
    siteBtn.addEventListener('click', function () { trackReviewClick('site'); });
    DOM.reviewButtons.appendChild(siteBtn);

    DOM.review.hidden = false;

    // Also show share
    showShare();
  }

  /* ============================================================
     STAFF HELP REQUEST (unsatisfied customers)
     ============================================================ */
  function showStaffHelp() {
    if (!DOM.review) return;

    DOM.reviewHeadline.textContent = pick(T.help_headline);
    DOM.reviewSubline.textContent = pick(T.help_subline);
    DOM.reviewButtons.innerHTML = '';

    // Klaviyo support event
    var _learnq = window._learnq || [];
    var email = safeStorageGet('smr-customer-email');
    var record = safeStorageGet('smr-seeding-record');
    var data = {};
    try { data = record ? JSON.parse(record) : {}; } catch (e) { /* ignore */ }

    if (email) {
      _learnq.push(['track', 'TERRAIN Support Requested', {
        'blend': data.blend || '',
        'postal_code': data.postalCode || '',
        'days_since_seeding': data.date ? Math.floor((Date.now() - new Date(data.date).getTime()) / 86400000) : null,
        'email': email
      }]);
    }

    DOM.reviewSubline.textContent = pick(T.help_sent);
    DOM.review.hidden = false;
  }

  /* ============================================================
     PRODUCT SHARE
     ============================================================ */
  function showShare(verdictStatus) {
    if (!DOM.share) return;
    // Avoid duplicate share buttons
    if (DOM.share.querySelector('.smr-share__btn')) return;

    var blend = window.__SEMER_STATE ? window.__SEMER_STATE.blend : null;
    var shareUrl = window.location.origin + '/pages/semer' + (blend ? '?blend=' + blend : '');

    // Adapt share text based on verdict status
    var shareText;
    if (verdictStatus === 'go') {
      shareText = pick(T.share_text_go);
    } else if (verdictStatus === 'caution' || verdictStatus === 'wait') {
      shareText = pick(T.share_text_other);
    } else {
      shareText = pick(T.share_text);
    }

    var shareIcon = '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" style="vertical-align:-2px;margin-right:6px"><path d="M4 12v5h12v-5M10 3v10M6 7l4-4 4 4"/></svg>';

    if (navigator.share) {
      var btn = document.createElement('button');
      btn.className = 'smr-share__btn';
      btn.type = 'button';
      btn.innerHTML = shareIcon + pick(T.share_btn);
      btn.addEventListener('click', function () {
        navigator.share({
          title: 'TERRAIN',
          text: shareText,
          url: shareUrl
        }).catch(function () { /* user cancelled */ });
      });
      DOM.share.appendChild(btn);
    } else {
      // Fallback: mailto link
      var subject = encodeURIComponent('TERRAIN — ' + pick(T.share_title));
      var body = encodeURIComponent(shareText + '\n\n' + shareUrl);
      var link = document.createElement('a');
      link.className = 'smr-share__btn';
      link.href = 'mailto:?subject=' + subject + '&body=' + body;
      link.innerHTML = shareIcon + pick(T.share_btn);
      DOM.share.appendChild(link);
    }

    DOM.share.hidden = false;
  }

  /* ============================================================
     BOOT
     ============================================================ */
  function init() {
    cacheDom();
    initTracker();

    // Expose hooks for semer-engine.js to call share earlier (result state)
    window.__SEMER_TOOLS_HOOKS = {
      showShare: function (verdictStatus) {
        if (DOM.share) showShare(verdictStatus);
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
